import 'react';
import { Link as Link$1 } from '@cbhq/cds-web/typography/Link';
import { jsx } from 'react/jsx-runtime';

/**
 * Provides support for a classic A tag and the React Router implementation.
 * Props params:
 * @param href: uses a plain <a> tag with no client side routing for external routes
 * @param to: uses a wrapped ReactRouter component, more React Link docs avaialable at
 *        https://reacttraining.com/react-router/web/api/Link
 */
function Link(props) {
  // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop
  const handleLinkClick = event => {
    event.preventDefault();
    const to = props.to,
      href = props.href;
    window.location.href = to || href || '/';
  };
  return /*#__PURE__*/jsx(Link$1, {
    href: props.to || props.href,
    className: props.className,
    onClick: handleLinkClick,
    children: [props.children]
  });
}
export { Link as default };
//# sourceMappingURL=Link.js.map
